var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('button',{staticClass:"bg-transparent border-0 position-fixed",attrs:{"id":"go-top"},domProps:{"innerHTML":_vm._s(_vm.icon)},on:{"click":_vm.scrollToTop}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }